import React, { useState } from 'react';
import { IonButton, IonIcon, IonText } from '@ionic/react';
import { arrowBack, grid, list } from 'ionicons/icons';
import SentencePart from './SentencePart';
import { useGlobalStore } from './stateManagement/globalZustand';
import { _dict } from './constants';
import './main.css';
import './SidebarSentence.css';
import { useUIStore } from './stateManagement/UIZustand';

interface SidebarSentenceProps {
  sentence: string[];
  handleReadSentence: () => void;
  showAutocomplete: boolean;
  setShowAutocomplete: (show: boolean) => void;
}

const SidebarSentence: React.FC<SidebarSentenceProps> = ({
  sentence,
  handleReadSentence,
  showAutocomplete,
  setShowAutocomplete
}) => {
  const { topSentences, deleteLastSentencePart, lang } = useGlobalStore();
  const { isSidebarHorizontal } = useUIStore();
  const [layoutMode, setLayoutMode] = useState(isSidebarHorizontal ? 'H' :  'V'); // 'H' for Horizontal, 'V' for Vertical

  return (
    <div className={`sidebar-col sidebar-col-${layoutMode}`}>
      <div className={`button-panel button-panel-${layoutMode}`}>
        {topSentences.length > 0 && (
          <IonButton
            color="light"
            size="large"
            expand="block"
            onClick={() => setShowAutocomplete(!showAutocomplete)}
          >
            <IonIcon icon={showAutocomplete ? grid : list} size="large" />
          </IonButton>
        )}
        {sentence.length > 0 && (
          <IonButton color="danger" size="large" expand="block" onClick={deleteLastSentencePart}>
            <IonIcon icon={arrowBack} size="large" />
          </IonButton>
        )}
      </div>
      <div className={`sentence-parts-${layoutMode}`}>
        {sentence.length === 0 ? (
          <IonText color="light">{_dict.toBuildASentenceClickOnTheCardsInOrder[lang]}</IonText>
        ) : (
          sentence.map((label, idx) =>
            (
              <SentencePart
              key={idx}
              label={label}
              position={idx}
              onClick={handleReadSentence}
              layoutMode={layoutMode}  // Pass layoutMode to SentencePart
            />
            )
          )
        )}
      </div>
    </div>
  );
};

export default SidebarSentence;
